<template>
  <modal
    :show="show"
    @close="close()"
  >
    <form @submit.prevent="addTeamMember()">
      <div class="w-full h-full p-6 space-y-6">
        <div class="w-full flex justify-between">
          <h2 class="text-xl">
            Invite Team Member
          </h2>
        </div>
        <div class="col-span-6">
          <div class="max-w-xl text-sm text-gray-600">
            Please provide the email address of the person you would like to add to this team.
          </div>
        </div>

        <!-- Member Email -->
        <div class="col-span-6 sm:col-span-4">
          <jet-label
            for="email"
            value="Email"
          />
          <jet-input
            id="email"
            v-model="form.email"
            type="email"
            class="mt-1 block w-full"
          />
          <jet-input-error
            :message="form.errors.email"
            class="mt-2"
          />
        </div>

        <!-- Role -->
        <div
          v-if="availableRoles.length > 0"
          class="col-span-6 lg:col-span-4"
        >
          <jet-label
            for="roles"
            value="Role"
          />
          <jet-input-error
            :message="form.errors.role"
            class="mt-2"
          />

          <div class="relative z-0 mt-1 border border-gray-200 rounded-lg cursor-pointer">
            <button
              v-for="(role, i) in availableRoles"
              :key="role"
              type="button"
              class="relative px-4 py-3 inline-flex w-full rounded-lg focus:z-10 focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-200"
              :class="{'border-t border-gray-200 rounded-t-none': i > 0, 'rounded-b-none': i !== Object.keys(availableRoles).length - 1}"
              @click="form.role = role"
            >
              <div :class="{'opacity-50': form.role && form.role !== role}">
                <!-- Role Name -->
                <div class="flex items-center">
                  <div
                    class="text-sm text-gray-600 capitalize"
                    :class="{'font-semibold': form.role === role}"
                  >
                    {{ role }}
                  </div>

                  <svg
                    v-if="form.role === role"
                    class="ml-2 h-5 w-5 text-green-400"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  ><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                </div>
              </div>
            </button>
          </div>
        </div>
        <div class="flex justify-between">
          <button
            class="bg-green-400 w-2/5 py-2 rounded-lg"
            type="submit"
          >
            Send invite
          </button>
          <button
            class="bg-gray-300 w-2/5 py-2 rounded-lg"
            @click="close()"
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  </modal>
</template>

<script>
import Modal from '../../Jetstream/Modal.vue';
import JetInput from '../../Jetstream/Input.vue';
import JetInputError from '../../Jetstream/InputError.vue';
import JetLabel from '../../Jetstream/Label.vue';

export default {
  name: 'AddTeamMember',
  components: {
    Modal,
    JetInput,
    JetInputError,
    JetLabel,
  },
  props: {
    availableRoles: {
      type: Array,
      required: true,
    },
    availableStatuses: {
      type: Array,
      required: true,
    },
    team: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close'],
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        role: null,
      }),
    };
  },
  computed: {},
  watch: {},
  methods: {
    addTeamMember() {
      this.form.post(route('team-members.store', this.team), {
        errorBag: 'addTeamMember',
        preserveScroll: true,
        onSuccess: () => {
          this.$notify({
            type: 'success',
            title: 'Sent',
            text: `An invitation has been sent to ${this.form.email}`,
          }, 4000);

          this.form.reset();
          this.close();
        },

        onError: () => {
          this.$notify({
            type: 'danger',
            title: 'Something went wrong',
            text: 'Could not send invitation',
          }, 4000);
        },
      });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>

</style>
